module.exports = __webpack_public_path__ + "static/img/sd.c466d90e.svg";